<p-dialog
  (visibleChange)="handleVisibleChange($event)"
  [closable]="!isSubmitting()"
  [dismissableMask]="!isSubmitting()"
  [draggable]="false"
  [modal]="true"
  [style]="{ width: '36rem', maxWidth: '96vw' }"
  [visible]="visible()"
  header="Zatwierdzenie konfiguracji sprzedaży">
  @if (isLoading()) {
    <div class="flex min-h-40 items-center justify-center">
      <app-spinner-filled />
    </div>
  } @else if (status(); as status) {
    @if (status.isAvailable) {
      <div class="space-y-4">
        <p class="leading-6 text-gray-700">
          Czy na pewno chcesz zatwierdzić konfigurację? Zatwierdzenie
          konfiguracji zablokuje jej edycję oraz spowoduje wygenerowanie i
          wysłanie ankiet do użytkowników.
        </p>

        @if (status.questionnairesWillBeGenerated === false) {
          <div
            class="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
            Dla tej konfiguracji ankiety nie zostaną wygenerowane.
          </div>
        } @else if (status.orders; as orders) {
          <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
            <div class="mb-2 font-semibold text-gray-900">
              Ilość zamówień do wygenerowania ankiet:
            </div>

            <div class="space-y-1 text-sm text-gray-700">
              <div>Zamówienia opłacone: {{ orders.paid }}</div>
              <div>
                Zamówienia częściowo zrealizowane:
                {{ orders.partiallyCompleted }}
              </div>
              <div>
                Zamówienia częściowo zwrócone:
                {{ orders.partiallyRefunded }}
              </div>
            </div>
          </div>
        }
      </div>

      <div class="mt-6 flex justify-end gap-4">
        <p-button
          (onClick)="confirmEvent.emit()"
          [disabled]="isSubmitting()"
          [label]="isSubmitting() ? 'Zatwierdzanie...' : 'Zatwierdź'"
          appPrimengButton />

        <p-button
          (onClick)="cancelEvent.emit()"
          [disabled]="isSubmitting()"
          appPrimengButton
          label="Anuluj"
          severity="secondary" />
      </div>
    } @else {
      <div class="space-y-4">
        <p class="leading-6 text-gray-700">
          {{
            status.errorMessage ||
              'Zatwierdzenie tej konfiguracji sprzedaży jest obecnie niedostępne.'
          }}
        </p>
      </div>

      <div class="mt-6 flex justify-end">
        <p-button
          (onClick)="cancelEvent.emit()"
          appPrimengButton
          label="Zamknij"
          severity="secondary" />
      </div>
    }
  }
</p-dialog>
